import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import {UserContext} from '../../UserContext'
import {ReactComponent as MinhasFotos} from '../../Assets/feed.svg'
import {ReactComponent as Estatisticas} from '../../Assets/estatisticas.svg'
import {ReactComponent as Adicionar} from '../../Assets/adicionar.svg'
import {ReactComponent as Sair} from '../../Assets/sair.svg'
import styles from './UserHeaderNav.module.css'
import useMedia from '../../Hooks/useMedia'

const UserHeaderNav = () => {
  const {userLogout} = React.useContext(UserContext)
  const [mobileMenu, setMobileMenu] = React.useState(null)
  const mobile = useMedia('(max-width: 40rem')
 
  const {pathname} = useLocation()
  React.useEffect(() => {
    setMobileMenu(null)
  }, [pathname])

  return (
    <>
    {
        mobile &&
        <button
        aria-label='Menu'
        className={`${styles.mobileButton} ${mobileMenu && styles.mobileActive}`}
        onClick={() => setMobileMenu(!mobileMenu)}
        >
        </button>
    }
    <nav className={
        `${mobile ? styles.navMobile : styles.nav}
         ${mobileMenu  && styles.navMobileActive} `}
    >
        <NavLink to='/conta' end>
            <MinhasFotos />
            {mobile && 'Minhas fotos'}
        </NavLink>
        <NavLink to='/conta/estatisticas'>
            <Estatisticas />
           {mobile && 'Estatisticas'}
        </NavLink>
        <NavLink to='/conta/postar'>
            <Adicionar />
            {mobile && 'Adicionar foto'}
        </NavLink>
        <button onClick={userLogout}>
            <Sair />
            {mobile && 'Sair'}
        </button>
    </nav>
    </>
  )
}

export default UserHeaderNav